'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _reducers = require('./reducers');

var _reducers2 = _interopRequireDefault(_reducers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var middleware = [_reduxThunk2.default];

    if (process.env.NODE_ENV !== 'production') {
        var logger = (0, _reduxLogger2.default)();
        middleware.push(logger);
    }

    var finalCreateStore = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware))(_redux.createStore);

    var rootReducer = (0, _reducers2.default)();
    var store = finalCreateStore(rootReducer);
    return store;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/store.js
// module id = 454
// module chunks = 0